/**
 * Developed By Aritra Basak, EY
 * (Latest )
 */
import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { Stepper } from "@material-ui/core";
import { Step } from "@material-ui/core";
import { StepLabel } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import VerifiedUserTwoToneIcon from "@material-ui/icons/VerifiedUserTwoTone";
import CancelTwoToneIcon from "@material-ui/icons/CancelTwoTone";
import { Divider } from "@mui/material";
import { Paper } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { RadioGroup } from "@mui/material";
import { Radio } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { FormLabel } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { Link } from "react-router-dom";
import { asyncPost } from "../../../common/utils";
import { URI } from "../../../constants";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import {
  RESEND_OTP_TIMEOUT,
  RESEND_OTP_CHANCE,
} from "../../../constants/dataconstants";
import "../../../assets/styles/V3.css";
import AadhaarInput from "../AadhaarInput";

const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "white !important",
  },
  stepper: {
    display: "flex",
    "& .MuiStepIcon-active": { color: global.secondaryColour },
    "& .MuiStepIcon-completed": { color: global.secondaryColour },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ccc" },
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%",
    padding: theme.spacing(5),
  },
  button: {
    margin: theme.spacing(1),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

function VerifyAbhaV3() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [authValue, setAuthValue] = React.useState("");
  const [authMode, setAuthMode] = React.useState("");
  const [txnId, setTxnId] = React.useState("");
  const [authCode, setAuthCode] = React.useState("");
  const [xToken, setXToken] = React.useState("");
  const [patientName, setPatientName] = React.useState("");
  const [healthIdRes, setHealthIdRes] = React.useState("");
  const [healthIdNoRes, setHealthIdNoRes] = React.useState("");
  const [mobileRes, setMobileRes] = React.useState();
  const [dobRes, setDobRes] = React.useState();
  const [dob, setDob] = React.useState();
  const [genderRes, setGenderRes] = React.useState();
  const [addressRes, setAddressRes] = React.useState("");
  const [districtCodeRes, setDistrictCodeRes] = React.useState();
  const [stateCodeRes, setStateCodeRes] = React.useState();
  const [pinCodeRes, setPinCodeRes] = React.useState("");
  const [kycPhotoRes, setKycPhotoRes] = React.useState();
  const [showLoader, setShowLoader] = React.useState(false);
  const [profileImageRes, setProfileImageRes] = React.useState();
  const [modalData, setModalData] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [modalFor, setModalFor] = React.useState("default");
  const [modalError, setModalError] = React.useState(0);
  const [buttonText, setButtonText] = React.useState("RESEND OTP");
  const [resendOtpChance, setResendOtpChance] = React.useState(0);
  const [isNewProfile, setIsNewProfile] = React.useState("");
  const [yearOfBirth, setYearOfBirth] = React.useState("");
  const [stateName, setStateName] = React.useState(null);
  const [districtName, setDistrictName] = React.useState(null);
  const [selectedMethodValue, setSelectedMethodValue] = React.useState(
    global.isGovtEntity === 1 ? "fetchMobile" : "mobile"
  );
  const [abhaProfileList, setAbhaProfileList] = React.useState([]);
  const [intervalId, setIntervalId] = React.useState(null);
  const [showAadhaar, setShowAadhaar] = React.useState(false);
  const [isAbhaGenerated, setIsAbhaGenerated] = React.useState(true);
  const [updatesComplete, setUpdatesComplete] = React.useState(false);
  const [preferredAbhaAddress, setPreferredAbhaAddress] = React.useState(null);
  const [phrAddress, setPhrAddress] = React.useState([]);

  const modalWidth = Math.min(500, Math.max(300, modalData.length * 6)) + "px";

  useEffect(() => {
    if (updatesComplete) {
      backToHome();
      setUpdatesComplete(false); // Reset the updatesComplete state
    }
  }, [updatesComplete]);

  useEffect(() => {
    console.log(selectedMethodValue);
    selectedMethodValue === "mobile" || selectedMethodValue === "fetchMobile"
      ? setAuthValue(global.mobileNumber)
      : setAuthValue("");
  }, [selectedMethodValue]);

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleAuthValue = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAuthValue(value);
    } else {
      setAuthValue((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handleAuthCode = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAuthCode(value);
    } else {
      setAuthCode((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setAuthCode("");
      clearInterval(intervalId);
    }
    if (activeStep === 2 || activeStep === 3) {
      resetHooks();
      setActiveStep(0);
    } else {
      setActiveStep(0);
    }
    clearInterval(intervalId);
  };

  //if the handleModalOpen() is called without a parameter then by default "default" will be set in modalForValue else if value is passed then that value will be set.
  const handleModalOpen = (modalForValue = "default", isError = 0) => {
    modalForValue === "default"
      ? setModalFor("default")
      : global.isGovtEntity === 1
      ? setModalFor("2ndStage")
      : setModalFor("default");
    setModalError(isError);
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  const resendOtpButtontext = () => {
    let count = parseInt(resendOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0 && count < RESEND_OTP_CHANCE) {
      const id = setInterval(() => {
        setButtonText("RESEND OTP AFTER: " + i + " sec");
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setResendOtpChance(count.toString());
          count > RESEND_OTP_CHANCE
            ? setButtonText("CANNOT USE RESEND OTP")
            : setButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
    if (count >= RESEND_OTP_CHANCE) {
      setButtonText("CANNOT USE RESEND OTP");
    }
  };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne();
    } else if (activeStep == 1) {
      return populateScreenFlowTwo();
    } else if (activeStep == 2) {
      return populateScreenFlowThree();
    } else if (activeStep == 3) {
      return populateScreenFlowFour();
    } else if (activeStep == 4) {
      return populateScreenFlowFive();
    }
  };
  //Function to get OTP for authentication with respect to the mode selected.
  const onGetOtp = async (value = null) => {
    if (selectedMethodValue === "aadhaar" && value !== null) {
      console.log("Aadhaar Value", value);
      setAuthValue(value);
    }
    clearInterval(intervalId); //Clearing the resendOTP button timer interval at the start, so that if someone exit the process before confirming the OTP and restart the process, correct OTP timer will be displayed.
    if (String(authValue.trim()) === "" && value === null) {
      selectedMethodValue === "mobile"
        ? setModalData("Kindly enter your Mobile Number.")
        : selectedMethodValue === "aadhaar"
        ? setModalData("Kindly enter your Aadhaar Number")
        : setModalData("Kindly enter your ABHA Number or ABHA Address");
      handleModalOpen();
      return false;
    }

    if (
      selectedMethodValue === "mobile" &&
      String(authValue.trim()).length !== 10
    ) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (
      selectedMethodValue === "mobile" &&
      String(authValue.trim()).match(/^[0-9]+$/) === null
    ) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (selectedMethodValue === "aadhaar" && value.trim().length !== 12) {
      setModalData("Kindly enter a valid Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (selectedMethodValue === "aadhaar" && value.match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a valid Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo =
      selectedMethodValue === "mobile"
        ? {
            //For Mobile Verification
            loginId: authValue,
            loginHint: "mobile",
          }
        : selectedMethodValue === "aadhaar"
        ? {
            //For Aadhaar Verification
            loginId: value,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number"
        ? {
            //For ABHA Number Verification
            loginId: authValue,
            loginHint: "abha-number",
            authMethod: authMode,
          }
        : {
            //For ABHA Address Verification
            loginId: authValue,
            loginHint: "abha-address",
            authMethod: authMode,
          };
    // debugger;
    // for the rest process other than fetch mobile
    const res = await asyncPost(URI.v3authInit, __oo, true, true, global.token);
    if (res.status === "Success" || res.status == 2000) {
      //debugger;
      setTxnId(res.resObject.txnId);
      setIsAbhaGenerated(true);
      selectedMethodValue === "mobile"
        ? setModalData(
            "Successfully sent OTP to the Communication Mobile number ending with ******" +
              String(authValue).substring(6, 11)
          )
        : setModalData(res.resObject.message);
      handleModalOpen();
      handleNext();
      resendOtpButtontext();
      setShowLoader(false);
    } else {
      //debugger;
      setShowLoader(false);
      setIsAbhaGenerated(true);
      if (res && res.resObject) {
        if (
          res.resObject.hasOwnProperty("error") &&
          (String(JSON.stringify(res.resObject.error.code)).includes(
            "ABDM-1115"
          ) ||
            String(JSON.stringify(res.resObject.error.message)).includes(
              "The Communication Mobile Number you have entered does not match with any of the records. Please enter a different Communication Mobile Number."
            ))
        ) {
          setIsAbhaGenerated(false);
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          Array.isArray(res.resObject) &&
          res.resObject[0]?.code &&
          res.resObject[0]?.message
        ) {
          setModalData(`${res.resObject[0].code} ${res.resObject[0].message}`);
          handleModalOpen("default", 1);
          return false;
        } else if (
          res.resObject.hasOwnProperty("loginId") &&
          res.resObject.loginId === "Invalid LoginId"
        ) {
          selectedMethodValue === "mobile"
            ? setModalData(
                res.resObject.loginId + ". Kindly enter a valid Mobile Number."
              )
            : setModalData(
                res.resObject.loginId + ". Kindly enter a valid Aadhaar Number."
              );
          handleModalOpen("default", 1);
          return false;
        } else if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("error")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          res.resObject.hasOwnProperty("code") &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.code + "," + res.resObject.message);
          handleModalOpen("default", 1);
          return false;
        } else {
          setModalData(res.resObject);
          handleModalOpen("default", 1);
          return false;
        }
      } else {
        console.error("Response object or resObject is undefined:", res);
        setModalData("An unexpected error occurred. Please try again.");
        handleModalOpen("default", 1);
        return false;
      }
    }
  };

  const fetchAbhaProfile = async () => {
    if (String(authValue.trim()) === "") {
      setModalData("Kindly enter your Mobile Number.");
      handleModalOpen();
      return false;
    }

    if (
      selectedMethodValue === "fetchMobile" &&
      String(authValue.trim()).length !== 10
    ) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (
      selectedMethodValue === "fetchMobile" &&
      String(authValue.trim()).match(/^[0-9]+$/) === null
    ) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      requestValue: authValue,
    };

    const res = await asyncPost(
      URI.v3fetchAbha,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      setTxnId(res.resObject[0].txnId);
      setIsAbhaGenerated(true);
      setAbhaProfileList(res.resObject[0].ABHA);
      setModalData(
        "Successfully fetched ABHA profiles linked to the Communication Mobile number ending with ******" +
          String(authValue).substring(6, 11)
      );
      handleModalOpen();
      handleNext();
      resendOtpButtontext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setIsAbhaGenerated(true);
      if (res && res.resObject) {
        if (
          res.resObject.hasOwnProperty("error") &&
          (String(JSON.stringify(res.resObject.error.code)).includes(
            "ABDM-1115"
          ) ||
            String(JSON.stringify(res.resObject.error.message)).includes(
              "The Communication Mobile Number you have entered does not match with any of the records. Please enter a different Communication Mobile Number."
            ))
        ) {
          setIsAbhaGenerated(false);
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          Array.isArray(res.resObject) &&
          res.resObject[0]?.code &&
          res.resObject[0]?.message
        ) {
          setModalData(`${res.resObject[0].code} ${res.resObject[0].message}`);
          handleModalOpen("default", 1);
          return false;
        } else if (
          res.resObject.hasOwnProperty("loginId") &&
          res.resObject.loginId === "Invalid LoginId"
        ) {
          setModalData(
            res.resObject.loginId + ". Kindly enter a valid Mobile Number."
          );
          handleModalOpen("default", 1);
          return false;
        } else if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("error")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          res.resObject.hasOwnProperty("code") &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.code + "," + res.resObject.message);
          handleModalOpen("default", 1);
          return false;
        } else if (res.resObject.hasOwnProperty("mobile")) {
          setModalData(res.resObject.mobile);
          handleModalOpen("default", 1);
          return false;
        }
      } else {
        if (res.responseMessage.toLowerCase().includes("failure")) {
          setModalData(res.responseMessage);
          handleModalOpen("default", 1);
          return false;
        }
        console.error("Response object or resObject is undefined:", res);
        setModalData("An unexpected error occurred. Please try again.");
        handleModalOpen("default", 1);
        return false;
      }
    }
  };

  const abhaFetchSendOtp = async (indexNumber) => {
    if (indexNumber === null || indexNumber === "") {
      setModalData("Kindly select an ABHA Profile to proceed.");
      handleModalOpen();
      return false;
    }
    setAuthValue(indexNumber);
    clearInterval(intervalId);
    setShowLoader(true);
    const __oo = {
      requestValue: indexNumber,
      txnId: txnId,
    };
    const res = await asyncPost(
      URI.v3findAbhaSendOtp,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      setTxnId(res.resObject.txnId);
      setModalData(res.resObject.message);
      resendOtpButtontext();
      setShowLoader(false);
      handleModalOpen();
      handleNext();
    } else {
      //debugger;
      setShowLoader(false);
      setIsAbhaGenerated(true);
      if (res && res.resObject) {
        if (res.resObject.hasOwnProperty("error")) {
          setIsAbhaGenerated(false);
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          Array.isArray(res.resObject) &&
          res.resObject[0]?.code &&
          res.resObject[0]?.message
        ) {
          setModalData(`${res.resObject[0].code} ${res.resObject[0].message}`);
          handleModalOpen("default", 1);
          return false;
        } else if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("error")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          res.resObject.hasOwnProperty("code") &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.code + "," + res.resObject.message);
          handleModalOpen("default", 1);
          return false;
        } else {
          setModalData(res.resObject);
          handleModalOpen("default", 1);
          return false;
        }
      } else {
        console.error("Response object or resObject is undefined:", res);
        setModalData("An unexpected error occurred. Please try again.");
        handleModalOpen("default", 1);
        return false;
      }
    }
  };

  //Function to resend OTP for authentication with the respective selected mode.
  const resendConfirmOtp = async () => {
    setShowLoader(true);
    var count = parseInt(resendOtpChance);
    count++;
    setResendOtpChance(count);
    const __oo =
      selectedMethodValue === "mobile"
        ? {
            loginId: authValue,
            loginHint: "mobile",
          }
        : selectedMethodValue === "aadhaar"
        ? {
            loginId: authValue,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number"
        ? {
            //For ABHA Number Verification
            loginId: authValue,
            loginHint: "abha-number",
            authMethod: authMode,
          }
        : {
            //For ABHA Address Verification
            loginId: authValue,
            loginHint: "abha-address",
            authMethod: authMode,
          };
    const res = await asyncPost(URI.v3authInit, __oo, true, true, global.token);
    if (res.status === "Success" || res.status == 2000) {
      resendOtpButtontext();
      setShowLoader(false);
      //debugger;
      setTxnId(res.resObject.txnId);
      if (res.resObject.hasOwnProperty("message")) {
        setModalData(res.resObject.message);
        handleModalOpen();
        return false;
      } else {
        setModalData("OTP sent to the registered mobile number.");
        handleModalOpen();
        return false;
      }
    } else {
      setShowLoader(false);
      if (
        parseInt(res.statusCode) === 0 &&
        res.resObject.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.message);
        handleModalOpen("default", 1);
        return false;
      } else if (String(res.responseMessage).includes("Failure")) {
        setModalData(
          "Message from ABDM : Could not resend OTP. Please try again after sometime."
        );
        handleModalOpen("default", 1);
        return false;
      } else if (
        res.resObject.hasOwnProperty("code") &&
        res.resObject.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.code + "," + res.resObject.message);
        handleModalOpen("default", 1);
        return false;
      }
    }
    // debugger;
  };

  // To verify the generated OTP in the previous step and proceed to next page
  const onConfirm = async () => {
    if (authCode.trim() == "") {
      setModalData("Kindly Enter your OTP first.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo =
      selectedMethodValue === "fetchMobile"
        ? {
            requestValue: authCode,
            txnId: txnId,
          }
        : selectedMethodValue === "mobile"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "mobile",
          }
        : selectedMethodValue === "aadhaar"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number" && authMode === "AADHAAR_OTP"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "aadhaar",
          }
        : selectedMethodValue === "number" && authMode === "MOBILE_OTP"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "mobile",
          }
        : selectedMethodValue === "address" && authMode === "MOBILE_OTP"
        ? {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "address-mobile",
          }
        : {
            txnId: txnId, //transaction ID
            otp: authCode,
            loginHint: "address-aadhaar",
          };

    if (selectedMethodValue === "fetchMobile") {
      setShowLoader(true);
      const res = await asyncPost(
        URI.v3findAbhaVerifyOtp,
        __oo,
        true,
        true,
        global.token
      );
      if (res.status === "Success") {
        setXToken(res.resObject.token);
        const __oo2 = {
          token: res.resObject.token,
        };
        const res2 = await asyncPost(
          URI.v3findAbhaGetProfile,
          __oo2,
          true,
          true,
          global.token
        );
        if (res2.status === "Success") {
          setHealthIdRes(res2.resObject.preferredAbhaAddress);
          setPreferredAbhaAddress(res2.resObject.preferredAbhaAddress);
          setPhrAddress(
            res2.resObject.hasOwnProperty("phrAddress") &&
              res2.resObject.phrAddress !== null &&
              res2.resObject.phrAddress.length > 1
              ? res2.resObject.phrAddress
              : null
          );
          setHealthIdNoRes(res2.resObject.ABHANumber);
          const day =
            res2.resObject.hasOwnProperty("dayOfBirth") &&
            res2.resObject.dayOfBirth !== null
              ? res2.resObject.dayOfBirth.trim().length === 1
                ? "0" + res2.resObject.dayOfBirth
                : res2.resObject.dayOfBirth
              : "01";

          const month =
            res2.resObject.hasOwnProperty("monthOfBirth") &&
            res2.resObject.monthOfBirth !== null
              ? res2.resObject.monthOfBirth.trim().length === 1
                ? "0" + res2.resObject.monthOfBirth
                : res2.resObject.monthOfBirth
              : "01";
          setDob(day + "/" + month + "/" + res2.resObject.yearOfBirth);
          res2.resObject.hasOwnProperty("monthOfBirth") &&
          res2.resObject.monthOfBirth !== null &&
          res2.resObject.hasOwnProperty("dayOfBirth") &&
          res2.resObject.dayOfBirth !== null
            ? setDobRes(day + "/" + month + "/" + res2.resObject.yearOfBirth)
            : setDobRes(res2.resObject.yearOfBirth);
          setPatientName(res2.resObject?.name || res2.resObject?.fullName);
          setGenderRes(res2.resObject.gender);
          setKycPhotoRes(res2.resObject.profilePhoto);
          setMobileRes(res2.resObject.mobile);
          setAddressRes(res2.resObject.address || "");
          setDistrictCodeRes(res2.resObject.districtCode);
          setStateCodeRes(res2.resObject.stateCode);
          setPinCodeRes(res2.resObject.pincode || "");
          setYearOfBirth(res2.resObject.yearOfBirth);
          setStateName(res2.resObject?.stateName || "");
          setDistrictName(res2.resObject?.districtName || "");
          setIsNewProfile(false);
          setShowLoader(false);
          handleNext();
          setModalData("Your ABHA profile has been verified successfully.");
          handleModalOpen();
          clearInterval(intervalId);
        } else {
          setShowLoader(false);
          if (
            parseInt(res2.statusCode) === 0 &&
            res2.resObject.hasOwnProperty("error")
          ) {
            setModalData(res2.resObject.error.message);
            handleModalOpen("default", 1);
            return false;
          } else if (
            parseInt(res2.statusCode) === 0 &&
            res2.resObject.hasOwnProperty("message")
          ) {
            setModalData(
              res2.resObject.message === "Invalid X-token"
                ? "Invalid OTP. Enter the correct OTP."
                : res2.resObject.message
            );
            handleModalOpen("default", 1);
            return false;
          } else if (String(res2.responseMessage).includes("Failure")) {
            setModalData(
              "Message from ABDM : Could not get verified profile. Please try again after sometime."
            );
            handleModalOpen("default", 1);
            return false;
          }
        }
      }
    } else {
      const res = await asyncPost(
        URI.v3authConfirm,
        __oo,
        true,
        true,
        global.token
      );
      console.log("authConfirm : " + JSON.stringify(res.resObject));
      if (res.status === "Success") {
        //debugger;
        if (
          res.resObject.hasOwnProperty("authResult") &&
          res.resObject.authResult === "failed"
        ) {
          setIsAbhaGenerated(true);
          setModalData(res.resObject.message);
          handleModalOpen("default", 1);
          setAuthCode("");
          setShowLoader(false);
          return false;
        } else {
          setXToken(res.resObject.token);
          setAbhaProfileList(res.resObject.accounts);
          console.log(res.resObject.accounts);
          setModalData("Your ABHA profile has been verified successfully.");
          handleModalOpen();
          clearInterval(intervalId);
          handleNext();
          setShowLoader(false);
        }
      } else {
        setShowLoader(false);
        setAuthCode("");
        if (
          String(
            res.resObject.hasOwnProperty("error") &&
              JSON.stringify(res.resObject.error.code)
          ).includes("ABDM-1114")
        ) {
          setIsAbhaGenerated(false);
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        }
        if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("error") &&
          res.resObject.error.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen("default", 1);
          return false;
        } else if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.message);
          handleModalOpen("default", 1);
          return false;
        } else if (String(res.responseMessage).includes("Failure")) {
          setModalData(
            "Could not validate OTP. Please try again after sometime."
          );
          handleModalOpen("default", 1);
          return false;
        } else if (
          res.resObject.hasOwnProperty("code") &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.code + "," + res.resObject.message);
          handleModalOpen("default", 1);
          return false;
        }
      }
    }
  };

  //To get the X-token and the T-token for fetching the Profile after validating the OTP
  const getProfile = async (abhaNumber, requestFor = null) => {
    setShowLoader(true);
    if (selectedMethodValue === "mobile") {
      //Verification Method is Mobile Number
      const __oo = {
        ttoken: xToken,
        abhaNumber: abhaNumber,
        txnId: txnId,
      };
      const res = await asyncPost(
        URI.v3getVerifiedProfileApi1,
        __oo,
        true,
        true,
        global.token
      );
      if (res.status === "Success") {
        setXToken(res.resObject.token);
        const __oo1 = {
          token: res.resObject.token,
        };
        const res2 = await asyncPost(
          URI.v3getVerifiedProfileApi2,
          __oo1,
          true,
          true,
          global.token
        );
        console.log(
          "v3getVerifiedProfileApi_Response : " + JSON.stringify(res2.resObject)
        );
        if (res2.status === "Success") {
          setHealthIdRes(res2.resObject.preferredAbhaAddress);
          setPreferredAbhaAddress(res2.resObject.preferredAbhaAddress);
          setPhrAddress(
            res2.resObject.hasOwnProperty("phrAddress") &&
              res2.resObject.phrAddress !== null &&
              res2.resObject.phrAddress.length > 1
              ? res2.resObject.phrAddress
              : null
          );
          setHealthIdNoRes(res2.resObject.ABHANumber);
          const day =
            res2.resObject.hasOwnProperty("dayOfBirth") &&
            res2.resObject.dayOfBirth !== null
              ? res2.resObject.dayOfBirth.trim().length === 1
                ? "0" + res2.resObject.dayOfBirth
                : res2.resObject.dayOfBirth
              : "01";

          const month =
            res2.resObject.hasOwnProperty("monthOfBirth") &&
            res2.resObject.monthOfBirth !== null
              ? res2.resObject.monthOfBirth.trim().length === 1
                ? "0" + res2.resObject.monthOfBirth
                : res2.resObject.monthOfBirth
              : "01";
          setDob(day + "/" + month + "/" + res2.resObject.yearOfBirth);
          res2.resObject.hasOwnProperty("monthOfBirth") &&
          res2.resObject.monthOfBirth !== null &&
          res2.resObject.hasOwnProperty("dayOfBirth") &&
          res2.resObject.dayOfBirth !== null
            ? setDobRes(day + "/" + month + "/" + res2.resObject.yearOfBirth)
            : setDobRes(res2.resObject.yearOfBirth);
          setPatientName(res2.resObject?.name || res2.resObject?.fullName);
          setGenderRes(res2.resObject.gender);
          setKycPhotoRes(res2.resObject.profilePhoto);
          setMobileRes(res2.resObject.mobile);
          setAddressRes(res2.resObject.address || "");
          setDistrictCodeRes(res2.resObject.districtCode);
          setStateCodeRes(res2.resObject.stateCode);
          setPinCodeRes(res2.resObject.pincode || "");
          res2.resObject.hasOwnProperty("districtCode")
            ? setDistrictCodeRes(res2.resObject.districtCode)
            : setDistrictCodeRes("");
          res2.resObject.hasOwnProperty("stateCode")
            ? setStateCodeRes(res2.resObject.stateCode)
            : setStateCodeRes("");
          res2.resObject.hasOwnProperty("pincode")
            ? setPinCodeRes(res2.resObject.pincode)
            : setPinCodeRes("");
          setYearOfBirth(res2.resObject.yearOfBirth);
          setStateName(res2.resObject?.stateName || "");
          setDistrictName(res2.resObject?.districtName || "");
          setIsNewProfile(false);
          setShowLoader(false);
          if (requestFor === null) {
            setUpdatesComplete(true); // Indicate that updates are complete
          } else {
            handleNext();
          }
        } else {
          setShowLoader(false);
          if (
            parseInt(res2.statusCode) === 0 &&
            res2.resObject.hasOwnProperty("error")
          ) {
            setModalData(res2.resObject.error.message);
            handleModalOpen("default", 1);
            return false;
          } else if (
            parseInt(res2.statusCode) === 0 &&
            res2.resObject.hasOwnProperty("message")
          ) {
            setModalData(res2.resObject.message);
            handleModalOpen("default", 1);
            return false;
          } else if (String(res2.responseMessage).includes("Failure")) {
            setModalData(
              "Message from ABDM : Could not get verified profile. Please try again after sometime."
            );
            handleModalOpen("default", 1);
            return false;
          }
        }
      } else {
        setShowLoader(false);
        if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.message);
          handleModalOpen("default", 1);
          return false;
        } else if (String(res.responseMessage).includes("Failure")) {
          setModalData(
            "Message from ABDM : Could not get X-Token. Please try again after sometime."
          );
          handleModalOpen("default", 1);
          return false;
        }
      }
    } else {
      //getting the profile for methods - abhaaddress, aadhaar number and mobile number.
      const __oo1 = {
        token: xToken,
        authMethod:
          selectedMethodValue === "address" ? "abha-address" : "other",
      };
      const res2 = await asyncPost(
        URI.v3getVerifiedProfileApi2,
        __oo1,
        true,
        true,
        global.token
      );
      console.log(
        "v3getVerifiedProfileApi_Response : " + JSON.stringify(res2.resObject)
      );
      if (res2.status === "Success") {
        // debugger;
        setHealthIdRes(
          res2.resObject?.preferredAbhaAddress || res2.resObject?.abhaAddress
        ); //using optional chaining (?), to handle the error of resObject being null.
        setPreferredAbhaAddress(
          res2.resObject?.preferredAbhaAddress || res2.resObject?.abhaAddress
        );
        setPhrAddress(
          res2.resObject.hasOwnProperty("phrAddress") &&
            res2.resObject.phrAddress !== null &&
            res2.resObject.phrAddress.length > 1
            ? res2.resObject.phrAddress
            : null
        );
        setHealthIdNoRes(
          res2.resObject?.ABHANumber || res2.resObject?.abhaNumber
        );
        const day =
          res2.resObject.hasOwnProperty("dayOfBirth") &&
          res2.resObject.dayOfBirth !== null &&
          res2.resObject.dayOfBirth.trim() !== "" // Check if dayOfBirth is not an empty string
            ? res2.resObject.dayOfBirth.trim().length === 1
              ? "0" + res2.resObject.dayOfBirth.trim() // Ensure to trim before padding
              : res2.resObject.dayOfBirth.trim() // Trim to remove any accidental spaces
            : "01"; // Default to "01" if not provided or empty

        const month =
          res2.resObject.hasOwnProperty("monthOfBirth") &&
          res2.resObject.monthOfBirth !== null &&
          res2.resObject.monthOfBirth.trim() !== "" // Check if monthOfBirth is not an empty string
            ? res2.resObject.monthOfBirth.trim().length === 1
              ? "0" + res2.resObject.monthOfBirth.trim() // Ensure to trim before padding
              : res2.resObject.monthOfBirth.trim() // Trim to remove any accidental spaces
            : "01"; // Default to "01" if not provided or empty

        setDob(day + "/" + month + "/" + res2.resObject.yearOfBirth);
        res2.resObject.hasOwnProperty("monthOfBirth") &&
        res2.resObject.monthOfBirth !== null &&
        res2.resObject.hasOwnProperty("dayOfBirth") &&
        res2.resObject.dayOfBirth !== null
          ? setDobRes(day + "/" + month + "/" + res2.resObject.yearOfBirth)
          : setDobRes(res2.resObject.yearOfBirth);
        setPatientName(res2.resObject?.name || res2.resObject?.fullName);
        setGenderRes(res2.resObject.gender);
        setKycPhotoRes(res2.resObject.profilePhoto);
        setMobileRes(res2.resObject.mobile);
        setAddressRes(res2.resObject.address || "");
        // setDistrictCodeRes(res2.resObject.districtCode);
        // setStateCodeRes(res2.resObject.stateCode);
        // setPinCodeRes(res2.resObject.pincode || res2.resObject.pinCode);
        res2.resObject.hasOwnProperty("districtCode")
          ? setDistrictCodeRes(res2.resObject.districtCode)
          : setDistrictCodeRes("");
        res2.resObject.hasOwnProperty("stateCode")
          ? setStateCodeRes(res2.resObject.stateCode)
          : setStateCodeRes("");
        res2.resObject.hasOwnProperty("pincode")
          ? setPinCodeRes(res2.resObject.pincode)
          : setPinCodeRes("");
        setYearOfBirth(res2.resObject.yearOfBirth);
        setStateName(res2.resObject?.stateName || "");
        setDistrictName(res2.resObject?.districtName || "");
        setIsNewProfile(false);
        setShowLoader(false);
        if (requestFor === null) {
          setUpdatesComplete(true); // Indicate that updates are complete
        } else {
          handleNext();
        }
      } else {
        setShowLoader(false);
        if (
          parseInt(res2.statusCode) === 0 &&
          res2.resObject.hasOwnProperty("message")
        ) {
          setModalData(res2.resObject.message);
          handleModalOpen("default", 1);
          return false;
        } else if (String(res2.responseMessage).includes("Failure")) {
          setModalData(
            "Message from ABDM : Could not get verified profile. Please try again after sometime."
          );
          handleModalOpen("default", 1);
          return false;
        }
      }
    }
  };

  //To get the Health Card of the verified profile
  const getHealthCard = async () => {
    setShowLoader(true);
    const __oo =
      selectedMethodValue === "address"
        ? {
            authMethod: "abha-address",
            token: xToken,
          }
        : {
            token: xToken,
          };
    // debugger;
    const res = await asyncPost(
      URI.v3getHealthCard,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      setProfileImageRes(res.resObject);
      handleNext();
      setShowLoader(false);
    } else if (res.status === 2000) {
      setProfileImageRes(res.data);
      handleNext();
      setShowLoader(false);
    } else {
      // debugger;
      setShowLoader(false);
      if (res.resObject.error && res.resObject.hasOwnProperty("message")) {
        setModalData(res.resObject.error.message);
        handleModalOpen("default", 1);
        return false;
      } else if (String(res.responseMessage).includes("Failure")) {
        setModalData(
          "Could not get ABHA card. Please try again after sometime."
        );
        handleModalOpen("default", 1);
        return false;
      } else {
        setModalData(res.responseMessage);
        handleModalOpen("default", 1);
        return false;
      }
    }
  };

  const handleRadioChange = (event) => {
    setSelectedMethodValue(event.target.value);
    if (String(authValue.trim()) !== "") setAuthValue("");
  };

  const postMessageToParent = async () => {
    const __oo = {
      name: patientName,
      healthId: preferredAbhaAddress,
      healthIdNumber: healthIdNoRes,
      gender: genderRes,
      mobile: mobileRes,
      dob: dob,
      isNew: isNewProfile,
      yearOfBirth: yearOfBirth,
      pngCard: profileImageRes,
      kycPhoto: kycPhotoRes,
      address: addressRes,
      districtCode: districtCodeRes,
      stateCode: stateCodeRes,
      pinCode: pinCodeRes,
      stateName: stateName,
      districtName: districtName,
      aadhaarNumber: "",
    };
    console.log(__oo);
    //Posting a Json message to the parent application.
    window.parent.postMessage(JSON.stringify(__oo), "*");
  };

  const backToHome = async () => {
    postMessageToParent();
    setActiveStep(0);
    resetHooks();
  };
  //This Event is trigerred from the parent web UI.
  window.addEventListener("message", function (event) {
    if (event.data === "closeWindow") {
      postMessageToParent();
    }
  });

  const resetHooks = () => {
    // by default at the start if fetchMobile option is present then bydefault fetchMobile will be selected else mobile..
    if (selectedMethodValue === "fetchMobile") {
      setSelectedMethodValue("fetchMobile");
      if (global.mobileNumber === "" || global.mobileNumber === null) {
        setAuthValue("");
      } else {
        setAuthValue(global.mobileNumber);
      }
    } else {
      setSelectedMethodValue("mobile");
      if (global.mobileNumber === "" || global.mobileNumber === null) {
        setAuthValue("");
      } else {
        setAuthValue(global.mobileNumber);
      }
    }
    setAuthCode("");
    setXToken("");
    setResendOtpChance(0);
    clearInterval(intervalId);
    setModalFor("1stStage");
    setIsAbhaGenerated(true);
    setPhrAddress([]);
  };

  //For downloading the card
  const downloadPng = async () => {
    // window.location.href = 'data:application/octet-stream;base64,' + profileImageRes;
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + profileImageRes; //Image Base64 Goes here
    a.download = "VerifiedHealthCard.png"; //File name Here
    a.click(); //Downloaded file
  };
  //Full Authentication form for generating OTP
  const populateScreenFlowOne = () => {
    return (
      <div className="my-2">
        <div className="text-center">
          <FormControl component="fieldset">
            <FormLabel
              component="legend"
              className="fw-bold"
              style={{ color: global.secondaryColour }}
            >
              Select a Method to Verify ABHA
            </FormLabel>
            <RadioGroup
              aria-label="method"
              name="controlled-radio-buttons-group"
              row
              className="text-center"
            >
              {global.isGovtEntity === 1 ? (
                <FormControlLabel
                  value="fetchMobile"
                  control={
                    <Radio
                      checked={selectedMethodValue === "fetchMobile"}
                      onChange={handleRadioChange}
                    />
                  }
                  label="Mobile Number"
                />
              ) : (
                <FormControlLabel
                  value="mobile"
                  control={
                    <Radio
                      checked={selectedMethodValue === "mobile"}
                      onChange={handleRadioChange}
                    />
                  }
                  label="Mobile Number"
                />
              )}

              <FormControlLabel
                value="aadhaar"
                control={
                  <Radio
                    checked={selectedMethodValue === "aadhaar"}
                    onChange={handleRadioChange}
                  />
                }
                label="Aadhaar Number"
              />
              <FormControlLabel
                value="address"
                control={
                  <Radio
                    checked={selectedMethodValue === "address"}
                    onChange={handleRadioChange}
                  />
                }
                label="ABHA Address"
              />
              <FormControlLabel
                value="number"
                control={
                  <Radio
                    checked={selectedMethodValue === "number"}
                    onChange={handleRadioChange}
                  />
                }
                label="ABHA Number"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <form className={classes.form} noValidate>
          <Grid
            container
            direction={"row"}
            spacing={5}
            alignItems="center"
            justifyContent="center"
          >
            {selectedMethodValue === "mobile" ||
            selectedMethodValue === "fetchMobile" ? (
              <React.Fragment>
                <Grid item>
                  <TextField
                    variant="standard"
                    margin="normal"
                    inputProps={{
                      maxLength: 10,
                    }}
                    label={"Communication Mobile Number"}
                    required
                    id="healthId"
                    value={authValue}
                    name="healthId"
                    style={{ marginTop: -1, width: "300px" }}
                    onChange={(e) => handleAuthValue(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    className={classes.submit}
                    onClick={() =>
                      selectedMethodValue === "fetchMobile"
                        ? fetchAbhaProfile()
                        : onGetOtp()
                    }
                  >
                    {selectedMethodValue === "fetchMobile"
                      ? "Fetch Profile"
                      : "Get OTP"}
                  </Button>
                </Grid>
              </React.Fragment>
            ) : selectedMethodValue === "aadhaar" ? (
              <Grid item>
                <AadhaarInput handleOtp={onGetOtp} />
              </Grid>
            ) : selectedMethodValue === "number" ? (
              <React.Fragment>
                <Grid item>
                  <TextField
                    variant="standard"
                    margin="normal"
                    inputProps={{ maxLength: 14 }}
                    label={"ABHA Number"}
                    required
                    id="abhaNumber"
                    value={authValue}
                    name="abhaNumber"
                    style={{ marginTop: -1, width: "300px" }}
                    onChange={(e) => handleAuthValue(e.target.value)}
                  />
                </Grid>
                <Grid item style={{ marginBottom: 10 }}>
                  <InputLabel id="loginAsLabel">Authentication Mode</InputLabel>
                  <Select
                    fullWidth
                    labelId="authMode"
                    id="authMode"
                    className={classes.selectEmpty}
                    onChange={(e) => {
                      setAuthMode(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled>
                      <strong>SELECT</strong>
                    </MenuItem>
                    <MenuItem value={"AADHAAR_OTP"}>
                      <strong>AADHAAR OTP</strong>
                    </MenuItem>
                    <MenuItem value={"MOBILE_OTP"}>
                      <strong>MOBILE OTP</strong>
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    className={classes.submit}
                    onClick={() => onGetOtp()}
                  >
                    Get OTP
                  </Button>
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Grid item>
                  <TextField
                    variant="standard"
                    margin="normal"
                    inputProps={{ maxLength: 22 }}
                    label={"ABHA Address"}
                    required
                    id="abhaAddress"
                    value={authValue}
                    name="abhaAddress"
                    style={{ marginTop: -1, width: "300px" }}
                    onChange={(e) => setAuthValue(e.target.value)}
                  />
                </Grid>
                <Grid item style={{ marginBottom: 10 }}>
                  <InputLabel id="loginAsLabel">Authentication Mode</InputLabel>
                  <Select
                    fullWidth
                    labelId="authMode"
                    id="authMode"
                    className={classes.selectEmpty}
                    onChange={(e) => {
                      setAuthMode(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled>
                      <strong>SELECT</strong>
                    </MenuItem>
                    <MenuItem value={"AADHAAR_OTP"}>
                      <strong>AADHAAR OTP</strong>
                    </MenuItem>
                    <MenuItem value={"MOBILE_OTP"}>
                      <strong>MOBILE OTP</strong>
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    className={classes.submit}
                    onClick={() => onGetOtp()}
                  >
                    Get OTP
                  </Button>
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </form>
      </div>
    );
  };

  const populateScreenFlowTwo = () => {
    if (selectedMethodValue === "fetchMobile") {
      return (
        <form
          className={classes.form}
          noValidate
          style={{ overflowY: "auto", height: "420px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h5
              style={{
                color: global.secondaryColour,
                marginBottom: "30px",
                fontWeight: "bold",
              }}
            >
              ABHA Profiles
            </h5>
          </div>
          <Grid
            container
            direction="column"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            {abhaProfileList.map((profile, index) => (
              <Grid item key={index}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button onClick={() => abhaFetchSendOtp(profile.index)}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        justifyContent: "start",
                      }}
                    ></div>
                    <div style={{ width: "400px" }} className="text-start">
                      <p>
                        Name:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <strong>{profile.name}</strong>
                        </span>
                      </p>
                      <p>
                        Abha Number:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <strong>{profile.ABHANumber}</strong>
                        </span>
                      </p>
                      {profile.hasOwnProperty("gender") &&
                      profile.gender !== null ? (
                        <p>
                          Gender:{" "}
                          <span style={{ color: global.secondaryColour }}>
                            <strong>
                              {profile.gender === "M"
                                ? "Male"
                                : profile.gender === "F"
                                ? "Female"
                                : "NA"}
                            </strong>
                          </span>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <KeyboardArrowRightIcon
                      style={{
                        position: "relative",
                        top: "0px",
                        left: "0px",
                        color: global.secondaryColour,
                      }}
                    />
                  </Button>
                </div>
                <hr></hr>
              </Grid>
            ))}
          </Grid>
        </form>
      );
    } else {
      return (
        <form className={classes.form} noValidate>
          <Grid
            container
            direction={"row"}
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <item>
                <TextField
                  variant="standard"
                  label={
                    selectedMethodValue === "mobile" ||
                    selectedMethodValue === "fetchMobile"
                      ? " Communication Mobile OTP"
                      : selectedMethodValue === "number" ||
                        selectedMethodValue === "address"
                      ? "Enter OTP"
                      : "Aadhaar OTP"
                  }
                  required
                  id="authCode"
                  value={authCode}
                  inputProps={{
                    maxLength: 6,
                    style: { width: "230px" },
                  }}
                  type="text"
                  autoComplete="off"
                  onChange={(e) => handleAuthCode(e.target.value)}
                  InputLabelProps={
                    selectedMethodValue === "mobile"
                      ? {
                          style: { marginTop: -5 }, // Adjust the negative margin value as needed
                        }
                      : { style: { marginTop: 0 } }
                  }
                />
              </item>
            </Grid>
            <Grid item>
              <item>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    paddingBottom: 10,
                  }}
                  onClick={() => onConfirm()}
                >
                  Verify & Proceed
                </Button>
              </item>
            </Grid>
            <Grid item>
              <item>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor:
                      buttonText === "RESEND OTP" ? "#f53169d9" : "#ccc",
                    color: "#fff",
                    paddingBottom: 10,
                  }}
                  onClick={() => resendConfirmOtp()}
                  disabled={buttonText === "RESEND OTP" ? false : true}
                >
                  {buttonText}
                </Button>
              </item>
            </Grid>

            <Grid item>
              <item
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                {resendOtpChance === 3 ? (
                  ""
                ) : (
                  <span>
                    You can resend OTP{" "}
                    <span style={{ color: "#D20062" }}>
                      {resendOtpChance > 0
                        ? parseInt(RESEND_OTP_CHANCE) -
                          parseInt(resendOtpChance) +
                          1
                        : 2}
                    </span>{" "}
                    more times
                  </span>
                )}
              </item>
            </Grid>
          </Grid>
        </form>
      );
    }
  };

  const populateScreenFlowThree = () => {
    if (selectedMethodValue === "fetchMobile") {
      return (
        <form className={classes.form} noValidate>
          <Grid
            container
            direction={"row"}
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <item>
                <TextField
                  variant="standard"
                  label={" Communication Mobile OTP"}
                  required
                  id="authCode"
                  value={authCode}
                  inputProps={{ maxLength: 6 }}
                  type="text"
                  autoComplete="off"
                  onChange={(e) => handleAuthCode(e.target.value)}
                  InputLabelProps={{
                    style: { marginTop: -22 }, // Adjust the negative margin value as needed
                  }}
                />
              </item>
            </Grid>
            <Grid item>
              <item>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    paddingBottom: 10,
                  }}
                  onClick={() => onConfirm()}
                >
                  Verify & Proceed
                </Button>
              </item>
            </Grid>
          </Grid>
        </form>
      );
    } else {
      return (
        <form
          className={classes.form}
          noValidate
          style={{ overflowY: "auto", height: "420px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h5
              style={{
                color: global.secondaryColour,
                marginBottom: "30px",
                fontWeight: "bold",
              }}
            >
              ABHA Profiles
            </h5>
          </div>
          <Grid
            container
            direction="column"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            {abhaProfileList.map((profile, index) => (
              <Grid item key={index}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button onClick={() => getProfile(profile.ABHANumber)}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        justifyContent: "start",
                      }}
                    >
                      {/* {profile.profilePhoto !== null ? (
                        <img
                          src={"data:image/png;base64, " + profile.profilePhoto}
                          alt="ABHA Patient"
                          style={{
                            height: "140px",
                            marginRight: "100px",
                          }}
                        />
                      ) : (
                        <PersonOutlineIcon
                          style={{
                            height: "140px",
                            marginRight: "100px",
                            color: global.secondaryColour,
                          }}
                          fontSize="large"
                        />
                      )} */}
                    </div>
                    <div style={{ width: "400px" }} className="text-start">
                      <p>
                        Name:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <strong>{profile.name}</strong>
                        </span>
                      </p>
                      <p>
                        Abha Address:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <input
                            type="text"
                            style={{
                              background: "transparent",
                              border: "none",
                              color: global.secondaryColour,
                              cursor: "default",
                              fontWeight: "bold",
                              fontSize: "medium",
                            }}
                            value={profile.preferredAbhaAddress}
                            readOnly
                          />
                        </span>
                      </p>
                      <p>
                        Abha Number:{" "}
                        <span style={{ color: global.secondaryColour }}>
                          <strong>{profile.ABHANumber}</strong>
                        </span>
                      </p>
                      {profile.hasOwnProperty("dob") && profile.dob !== null ? (
                        <p>
                          Date of Birth:{" "}
                          <span style={{ color: global.secondaryColour }}>
                            <strong>{profile.dob}</strong>
                          </span>
                        </p>
                      ) : (
                        ""
                      )}
                      {profile.hasOwnProperty("gender") &&
                      profile.gender !== null ? (
                        <p>
                          Gender:{" "}
                          <span style={{ color: global.secondaryColour }}>
                            <strong>
                              {profile.gender === "M"
                                ? "Male"
                                : profile.gender === "F"
                                ? "Female"
                                : "NA"}
                            </strong>
                          </span>
                        </p>
                      ) : (
                        ""
                      )}

                      {profile.hasOwnProperty("kycVerified") &&
                      profile.kycVerified !== null ? (
                        <p>
                          KYC Verified:{" "}
                          <span style={{ color: global.secondaryColour }}>
                            {profile.kycVerified.toString() === "True" ||
                            profile.kycVerified.toString() === "true" ? (
                              <VerifiedUserTwoToneIcon
                                style={{
                                  color: "#77E4C8",
                                  marginBottom: "1%",
                                }}
                              />
                            ) : (
                              <CancelTwoToneIcon
                                style={{
                                  color: "#f53169d9",
                                  marginBottom: "1%",
                                }}
                              />
                            )}
                          </span>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <KeyboardArrowRightIcon
                      style={{
                        position: "relative",
                        top: "0px",
                        left: "0px",
                        color: global.secondaryColour,
                      }}
                    />
                  </Button>
                  <Button
                    variant="default"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      height: "25px",
                    }}
                    onClick={() => getProfile(profile.ABHANumber, "AbhaCard")}
                  >
                    View ABHA Profile
                  </Button>
                </div>
                <hr></hr>
              </Grid>
            ))}
          </Grid>
        </form>
      );
    }
  };

  const populateScreenFlowFour = () => {
    //debugger;
    const profileImage = "data:image/png;base64, " + kycPhotoRes;
    return (
      <Table size="big">
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Number</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdNoRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Address</strong>
            </TableCell>
            {phrAddress !== null && phrAddress.length > 1 ? (
              <TableCell style={{ textAlign: "left" }}>
                <Select
                  id="state-preferredaddress"
                  value={preferredAbhaAddress}
                  onChange={(event) =>
                    setPreferredAbhaAddress(event.target.value)
                  }
                  style={{ width: "300px", textAlign: "center" }}
                >
                  <MenuItem value="" disabled>
                    Select the Preferred ABHA Address
                  </MenuItem>
                  {phrAddress.map((address) => (
                    <MenuItem key={address} value={address}>
                      {address}
                    </MenuItem>
                  ))}
                </Select>
              </TableCell>
            ) : (
              <TableCell style={{ textAlign: "left" }}>
                {preferredAbhaAddress}
              </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Name</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{patientName}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Gender</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {genderRes == "M" ? "Male" : "Female"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Mobile</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{mobileRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Date of Birth</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{dobRes}</TableCell>
          </TableRow>
          {console.log("State Name:", stateName)}
          {stateName && districtName ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>State</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {stateName} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>District</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {districtName}
              </TableCell>
            </TableRow>
          ) : null}
          {pinCodeRes !== null &&
          addressRes !== null &&
          addressRes.trim() !== "" &&
          pinCodeRes.trim() !== "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Address</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {addressRes} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Pincode</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>{pinCodeRes}</TableCell>
            </TableRow>
          ) : (
            ""
          )}

          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <img src={profileImage} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "##E5E4E2",
                  color: "#f53169d9",
                  width: "200px",
                }}
                onClick={() => getHealthCard()}
              >
                View ABHA Card
              </Button>
              <Button
                variant="contained"
                className="mx-2 "
                style={{
                  backgroundColor: "#f53169d9",
                  color: "#fff",
                }}
                onClick={() => backToHome()}
              >
                Save and Continue
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const populateScreenFlowFive = () => {
    const profileImageI = "data:image/png;base64, " + profileImageRes;
    return (
      <div className="imgcontainer">
        <div className="text-center">
          <img src={profileImageI} width={"80%"} />
        </div>

        <div style={{ textAlign: "center" }} className="button_container my-2">
          <Button
            variant="contained"
            className="mx-2"
            style={{
              backgroundColor: "##E5E4E2",
              color: "#f53169d9",
              width: "200px",
            }}
            onClick={() => downloadPng()}
          >
            Download ABHA Card
          </Button>
          <Button
            variant="contained"
            className="mx-2 "
            style={{
              backgroundColor: "#f53169d9",
              color: "#fff",
            }}
            onClick={() => backToHome()}
          >
            Save and Continue
          </Button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "10px" }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            >
              <Button
                style={
                  activeStep === 0 ? { color: "#ccc" } : { color: "#f53169d9" }
                }
                onClick={() => handleBack()}
                sx={{ mr: 1 }}
                disabled={activeStep === 0 ? true : false}
              >
                {" "}
                Back
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={handleModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{ timeout: 500 }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Fade in={modalState}>
          {modalFor === "2ndStage" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh", // Ensures full viewport height for centering
              }}
            >
              <Box
                sx={{
                  background: "white",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  p: 3,
                  minWidth: "300px",
                  maxWidth: "80vw",
                  width: modalWidth,
                  boxShadow: 24,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="25"
                    height="27"
                    viewBox="0 0 128 128"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                        .cls-2{fill:#404040}
                        .cls-3{fill:#9e9e9e}
                        .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                    />
                    <path
                      className="cls-2"
                      d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                    />
                    <path
                      className="cls-3"
                      d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                    />
                    <path
                      className="cls-2"
                      d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                    <path
                      className="cls-2"
                      d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                    <path
                      className="cls-2"
                      d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Information
                  </Typography>
                </Box>
                {/* Decorative Lines */}
                <Divider sx={{ width: "50%", mb: 0.5 }} />
                <Divider sx={{ width: "40%", mb: 2 }} />
                <Typography
                  variant="body1"
                  sx={{ whiteSpace: "pre-wrap", mb: 2 }}
                >
                  Choose the method with which you want to proceed.
                </Typography>
                <div style={{ display: "flex" }}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: global.secondaryColour,
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                    component={Link}
                    to="/newabhav3"
                  >
                    Aadhaar OTP
                  </Button>
                  <Button
                    variant="contained"
                    component={Link}
                    to="/demoAuthGenerateAbha"
                    className={classes.button}
                    style={{
                      backgroundColor: "#f53169d9",
                      color: "#fff",
                      paddingBottom: 10,
                      marginTop: 7,
                    }}
                  >
                    Demographics
                  </Button>
                </div>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh", // Ensures full viewport height for centering
              }}
            >
              <Box
                sx={{
                  background: "white",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  p: 3,
                  minWidth: "300px",
                  maxWidth: "80vw",
                  width: modalWidth,
                  boxShadow: 24,
                }}
              >
                {" "}
                {modalError === 1 ? (
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 50 50"
                      className="me-2"
                      width="25px"
                      height="27px"
                      fill="#000000"
                    >
                      <circle
                        style={{ fill: "#D75A4A" }}
                        cx="25"
                        cy="25"
                        r="25"
                      />
                      <polyline
                        style={{
                          fill: "none",
                          stroke: "#FFFFFF",
                          strokeWidth: 2,
                          strokeLinecap: "round",
                          strokeMiterlimit: 10,
                        }}
                        points="16,34 25,25 34,16"
                      />
                      <polyline
                        style={{
                          fill: "none",
                          stroke: "#FFFFFF",
                          strokeWidth: 2,
                          strokeLinecap: "round",
                          strokeMiterlimit: 10,
                        }}
                        points="16,16 25,25 34,34"
                      />
                    </svg>
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                      Error
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <svg
                      width="25"
                      height="27"
                      viewBox="0 0 128 128"
                      className="me-2"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <style>
                          {`.cls-1{fill:#ffe082}
                        .cls-2{fill:#404040}
                        .cls-3{fill:#9e9e9e}
                        .cls-4{fill:#f5f5f5}`}
                        </style>
                      </defs>
                      <path
                        className="cls-1"
                        d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                      />
                      <path
                        className="cls-2"
                        d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                      />
                      <path
                        className="cls-3"
                        d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                      />
                      <path
                        className="cls-2"
                        d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                      />
                      <line
                        className="cls-4"
                        x1="54"
                        x2="82"
                        y1="102"
                        y2="98"
                      />
                      <path
                        className="cls-2"
                        d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                      />
                      <line
                        className="cls-4"
                        x1="54"
                        x2="82"
                        y1="110"
                        y2="106"
                      />
                      <path
                        className="cls-2"
                        d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                      />
                    </svg>
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                      Information
                    </Typography>
                  </Box>
                )}
                {/* Decorative Lines */}
                <Divider sx={{ width: "50%", mb: 0.5 }} />
                <Divider sx={{ width: "40%", mb: 2 }} />
                <Typography
                  variant="body1"
                  sx={{ whiteSpace: "pre-wrap", mb: 2 }}
                >
                  {modalData}
                </Typography>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    paddingBottom: 10,
                    marginTop: 7,
                  }}
                  onClick={handleModalClose}
                >
                  OK
                </Button>
                {isAbhaGenerated != true ? (
                  <span
                    style={{
                      color: "#f53169d9",
                      fontWeight: "bold",
                    }}
                  >
                    or
                  </span>
                ) : (
                  ""
                )}
                {isAbhaGenerated != true &&
                  (global.isGovtEntity === 1 ? (
                    <Button
                      variant="contained"
                      color="default"
                      style={{
                        color: "#fff",
                        paddingBottom: 10,
                        marginTop: 7,
                      }}
                      onClick={() => handleModalOpen("2ndStage")}
                    >
                      Create ABHA
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="default"
                      style={{
                        color: "#fff",
                        paddingBottom: 10,
                        marginTop: 7,
                      }}
                      component={Link}
                      to="/newabhav3"
                      c
                    >
                      Create ABHA
                    </Button>
                  ))}
              </Box>
            </Box>
          )}
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default VerifyAbhaV3;
